import { html, render } from '../core/html.js';
import { t } from '../core/i18n.js';
import { routeHref } from '../core/url.js';
import { page } from '../components/chrome.js';
import { icon } from '../components/icon.js';

export const NotFoundPage = () =>
  render(page(html`
    <section class="notfound" aria-labelledby="notfound-title">
      <div class="shell notfound__inner">
        <p class="kicker">${t('notfound.label')}</p>
        <p class="notfound__code" aria-hidden="true">404</p>
        <h1 class="notfound__title" id="notfound-title">${t('notfound.title')}</h1>
        <p class="notfound__text">${t('notfound.description')}</p>
        <a class="btn btn--ink btn--lg" href="${routeHref('/')}">
          ${t('nav.backHome')}${icon('arrowRight', { size: 17 })}
        </a>
      </div>
    </section>
  `));
